/**
 * Life Ledger domain registry — single source of truth for UI.
 * Mirrors /app/backend/prompts/domains.py
 *
 * Two tiers:
 *  - life:  AuDHD personal signal (finance, health, diet, activity, mood, medication)
 *  - ops:   Operations Desk (post, pattern, song, eulogy, recipe, callout)
 */
import {
    Wallet, HeartPulse, Apple, Activity as ActivityIcon, Brain, Pill,
    FileText, Scissors, Music, Flower2, ChefHat, Eye, HelpCircle,
} from "lucide-react";

export const DOMAIN_META = {
    // Tier 1 — life
    finance:    { label: "Finance",    tier: "life", icon: Wallet,       cls: "dom-finance" },
    health:     { label: "Health",     tier: "life", icon: HeartPulse,   cls: "dom-health" },
    diet:       { label: "Diet",       tier: "life", icon: Apple,        cls: "dom-diet" },
    activity:   { label: "Activity",   tier: "life", icon: ActivityIcon, cls: "dom-activity" },
    mood:       { label: "Mood",       tier: "life", icon: Brain,        cls: "dom-mood" },
    medication: { label: "Medication", tier: "life", icon: Pill,         cls: "dom-medication" },

    // Tier 2 — operations desk
    post:     { label: "Post",     tier: "ops", icon: FileText,  cls: "dom-post" },
    pattern:  { label: "Pattern",  tier: "ops", icon: Scissors,  cls: "dom-pattern" },
    song:     { label: "Song",     tier: "ops", icon: Music,     cls: "dom-song" },
    eulogy:   { label: "Eulogy",   tier: "ops", icon: Flower2,   cls: "dom-eulogy" },
    recipe:   { label: "Recipe",   tier: "ops", icon: ChefHat,   cls: "dom-recipe" },
    callout:  { label: "Callout",  tier: "ops", icon: Eye,       cls: "dom-callout" },

    // Fallback
    other:    { label: "Other",    tier: "life", icon: HelpCircle, cls: "dom-other" },
};

export const LIFE_KEYS = Object.keys(DOMAIN_META).filter(k => DOMAIN_META[k].tier === "life");
export const OPS_KEYS  = Object.keys(DOMAIN_META).filter(k => DOMAIN_META[k].tier === "ops");
export const ALL_KEYS  = Object.keys(DOMAIN_META);
